import { defineNuxtPlugin } from '#app/nuxt'
import { LazyBlueprintEvent, LazyBlueprintNewsArticle, LazyBlueprintPage, LazyBlueprintPublication, LazyHeroDefault, LazyAccordion, LazyCardTextWithImage, LazyCardsGridWithText, LazyCollapse, LazyCustomForm, LazyHorizontalRule, LazyIframe, LazyImage, LazyImageWithText, LazyOverviewEvents, LazyOverviewNews, LazyOverviewPublications, LazySlider, LazyTeaserEvents, LazyTeaserNews, LazyTeaserPublications, LazyText, LazyTextWithLinks, LazyVideo, LazyVoting, LazySidebarCardContact, LazySidebarCardLinks } from '#components'
const lazyGlobalComponents = [
  ["BlueprintEvent", LazyBlueprintEvent],
["BlueprintNewsArticle", LazyBlueprintNewsArticle],
["BlueprintPage", LazyBlueprintPage],
["BlueprintPublication", LazyBlueprintPublication],
["HeroDefault", LazyHeroDefault],
["Accordion", LazyAccordion],
["CardTextWithImage", LazyCardTextWithImage],
["CardsGridWithText", LazyCardsGridWithText],
["Collapse", LazyCollapse],
["CustomForm", LazyCustomForm],
["HorizontalRule", LazyHorizontalRule],
["Iframe", LazyIframe],
["Image", LazyImage],
["ImageWithText", LazyImageWithText],
["OverviewEvents", LazyOverviewEvents],
["OverviewNews", LazyOverviewNews],
["OverviewPublications", LazyOverviewPublications],
["Slider", LazySlider],
["TeaserEvents", LazyTeaserEvents],
["TeaserNews", LazyTeaserNews],
["TeaserPublications", LazyTeaserPublications],
["Text", LazyText],
["TextWithLinks", LazyTextWithLinks],
["Video", LazyVideo],
["Voting", LazyVoting],
["SidebarCardContact", LazySidebarCardContact],
["SidebarCardLinks", LazySidebarCardLinks],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
